import type { Account, AppConfig } from '@/api/types';

/**
 * Where "Begin free child assessment" goes. A parent with a session (an account, or a check-in
 * already started as a guest) carries on; a visitor starts without an account when the API offers
 * it, and otherwise signs up first, as at launch.
 */
export const startPathFor = (account: Pick<Account, 'guest'> | null, config: Pick<AppConfig, 'guestCheckin'> | null): string =>
  account ? '/children' : config?.guestCheckin ? '/start' : '/signup';

/** The pages a guest may open; anything else asks for a sign-up first. */
export const guestMayOpen = (pathname: string): boolean =>
  pathname === '/children' || /^\/assessments\/[^/]+(\/review)?$/.test(pathname);
